// @flow

import type { JobOperationsById } from 'fc-operator-sampling-jobs/types'

// Libs
import React, { Component } from 'react'
import _isEmpty from 'lodash/isEmpty'

// Components
import Button from '@react-mdc/button'
import { Errors } from 'hfty-components-errors'
import Mask from 'fc-masks'

// Styles
const styles = {
  container: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    width: 300,
    backgroundColor: '#fff',
    color: '#fff',
    boxShadow: '-2px 0 2px rgba(0, 0, 0, 0.2)',
    padding: 15,
    overflow: 'auto',
  },
  componentStyle: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    minWidth: 350,
    maxWidth: '100vw',
    backgroundColor: '#fff',
    boxShadow: '-2px 0 2px rgba(0,0,0,0.1)',
    zIndex: 1000,
  },
  message: {
    padding: 20,
    color: 'black',
  },
}

type Props = {
  operations: Array<JobOperationsById>,
  onCancel: Function,
  onSubmit: Function,
  showExtraWarning: boolean,
}

export default class DeleteSoilJobs extends Component {
  props: Props
  onSubmit: Function
  onCancel: Function

  constructor(props: Props) {
    super(props)

    this.onSubmit = this.onSubmit.bind(this)
    this.onCancel = this.onCancel.bind(this)
    this.renderDeleteConfirmation = this.renderDeleteConfirmation.bind(this)

    this.state = {
      initialMessage: true,
    }
  }

  onSubmit(e: Event) {
    e.preventDefault()

    if (this.state.initialMessage) {
      this.setState({
        initialMessage: false,
      })
    } else {
      this.setState({
        initialMessage: true,
      })
      this.props.onSubmit(this.props.operations)
    }
  }

  onCancel(e: Event) {
    e.preventDefault()

    if (!this.state.initialMessage) {
      this.setState({
        initialMessage: true,
      })
    }
    this.props.onCancel(this.props.operations)
  }

  renderDeleteConfirmation(): React.Element<any> {
    let msg =
      this.props.operations.length > 1
        ? this.props.showExtraWarning && this.state.initialMessage
          ? 'Note that if you delete these jobs, they will be deleted along with any attached soil sampling points.'
          : 'Are you sure you want to delete these jobs?'
        : this.props.showExtraWarning && this.state.initialMessage
        ? 'Note that if you delete this job, it will be deleted along with any attached soil sampling points.'
        : 'Are you sure you want to delete this job?'

    msg = this.state.initialMessage ? (msg += ' Are you sure you want to proceed?') : msg

    return (
      <div style={styles.container}>
        <form>
          <Errors errors={this.props.operations.errors} labels={['error']} />
          <div style={styles.message}>{msg}</div>
          <div style={styles.message}>
            <Button raised primary onClick={this.onSubmit}>
              {this.props.showExtraWarning && this.state.initialMessage ? 'Yes' : 'Submit'}
            </Button>
            <Button raised primary style={{ marginLeft: 10 }} onClick={this.onCancel}>
              {this.props.showExtraWarning && this.state.initialMessage ? 'No' : 'Cancel'}
            </Button>
          </div>
        </form>
        <Mask enabled={this.props.operations.submitting} />
      </div>
    )
  }

  render(): ?React.Element<any> {
    if (_isEmpty(this.props.operations)) {
      return null
    }

    return this.renderDeleteConfirmation()
  }
}
